import { Zap, ArrowDown, CheckCircle2, TrendingUp, TrendingDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const CARD_ROWS = [
  { sym: 'NVDA', sig: 'Bull — data center',  chg: '+2.31%', up: true,  badge: null },
  { sym: 'META', sig: 'Ads beat · AI capex', chg: '+3.14%', up: true,  badge: null },
  { sym: 'TSLA', sig: 'Volume miss',          chg: '−1.73%', up: false, badge: null },
];

const PROJ_ROWS = [
  { sym: 'NVDA', sig: '↑ $910 – $935', badge: 'hit' },
  { sym: 'META', sig: '↑ $555 – $575', badge: 'beat' },
  { sym: 'MU',   sig: '↓ $770 – $790', badge: 'miss' },
];

const BADGE = { hit: 'b-hit', beat: 'b-beat', miss: 'b-miss' };
const BADGE_LABEL = { hit: 'Hit', beat: 'Beat', miss: 'Miss' };

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-in">
        <div className="hero-left">
          <div className="hero-badge"><Zap />AI Market Intelligence · Every Trading Day</div>
          <h1>What changed.<br />Why it matters.<br /><em>What's coming.</em></h1>
          <p className="hero-lead">
            Every market day, our AI agents scan earnings, analyst targets, competitor moves,
            supply-chain signals, and regulatory risks. One clear brief.{' '}
            <strong>Projections resolved at Today's close, This Week, This Month, and This Year.</strong>
          </p>
          <div className="hero-actions">
            <Link to="/register?plan=monthly" className="btn-primary">
              <Zap size={15} /> Start Pro for $14.95 / month
            </Link>
            <a href="#research" className="btn-secondary">
              See inside an issue <ArrowDown size={14} />
            </a>
          </div>
          <div className="hero-proof">
            <div className="proof-item"><div className="proof-n">~100</div><div className="proof-l">Stocks analyzed daily</div></div>
            <div className="proof-item"><div className="proof-n">Free</div><div className="proof-l">To register &amp; read</div></div>
            <div className="proof-item"><div className="proof-n">Public</div><div className="proof-l">Track record — no hiding</div></div>
          </div>
        </div>

        <div className="hcard" style={{marginTop: '-100px'}}>
          <div className="hcard-bar">
            <span className="hcard-issue">Mon · May 12, 2026 · Issue #104</span>
            <span className="hcard-live"><span className="live-dot" />Market open</span>
          </div>
          <div className="hcard-body">
            <div className="hcard-sec"><Zap size={12} />Market Pulse</div>
            {CARD_ROWS.map(r => (
              <div key={r.sym} className="hcard-row">
                <span className="hcard-sym">{r.sym}</span>
                <span className="hcard-sig">
                  {r.up
                    ? <TrendingUp size={12} style={{ color: 'var(--green)' }} />
                    : <TrendingDown size={12} style={{ color: 'var(--red)' }} />}
                  {r.sig}
                </span>
                <span className={`hcard-chg ${r.up ? 'up' : 'dn'}`}>{r.chg}</span>
              </div>
            ))}

            <div className="hcard-sec" style={{ marginTop: 16 }}>
              <Zap size={12} />Today's Final — resolved at close
            </div>
            {PROJ_ROWS.map(r => (
              <div key={r.sym} className="hcard-row">
                <span className="hcard-sym">{r.sym}</span>
                <span className="hcard-sig up">{r.sig}</span>
                <span className={`badge ${BADGE[r.badge]}`}>
                  <CheckCircle2 size={9} />{BADGE_LABEL[r.badge]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
